import * as React from 'react';
import { ComplexValue, ComponentProps } from 'ui/common';
import { UploadedFile } from 'app/area/case/features';
import { Thumbnail } from 'app/area/case/components/thumbnail';
import styles from '../fact-box.scss';
import { toHex } from 'ui/common/hex-converter';

interface FactItemImagesProps extends ComponentProps {
  uploadedFiles?: UploadedFile[];
  loadBlob?: (blobId: number, thumbnail: boolean) => Promise<Blob>;
  riskArea?: ComplexValue<number>;
}

export const ImagesFactItem = (props: FactItemImagesProps) => {
  const color = props.riskArea?.value && props.riskArea?.backgroundColor ? props.riskArea?.backgroundColor : undefined;
  const { uploadedFiles, loadBlob } = props;
  if (!uploadedFiles?.length) {
    return null;
  }
  return <div className={styles.thumbnail} style={{ borderColor: toHex(color)}}>
    <Thumbnail componentId={undefined} className={undefined} uploadedFiles={uploadedFiles} loadBlob={loadBlob} />
   </div>
  ;
};
